// extracted by mini-css-extract-plugin
export default {"root":"style_root__6O9+X","title":"style_title__xBX2k","status":"style_status__LDVyT"};